import * as React from 'react';
export const IcCarDriver = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M12 12a8 8 0 00-8 8v1a1 1 0 102 0v-1a6 6 0 01.31-1.9h.05a9.05 9.05 0 013.75 3.34A1 1 0 0011 22h2a1 1 0 00.89-.55 9 9 0 013.74-3.33h.06A6 6 0 0118 20v1a1 1 0 002 0v-1a8 8 0 00-8-8zm0 5a27.878 27.878 0 01-4.7-.72 6 6 0 019.4 0A27.878 27.878 0 0112 17zm0-6a4.5 4.5 0 10-4.5-4.5A4.51 4.51 0 0012 11z'
      fill='currentColor'
    />
  </svg>
);
